import * as React from "react";
import { useEffect } from "react";
import "../../proposols/step1/proposol.css";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { set_info1 } from "../../../Redux/action";
import { Col, Form, Input, Row, Select, Button, Alert } from "antd/lib";
import axios from "axios";
import Ownerdisplay from "./OwnerDisplay";

function OwnerProposal1({ showStep2, setShowStep2, Ref2 }) {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [formLayout] = useState("vertical");
  const vehicleDetail = useSelector((state) => state?.common?.vahanData);
  const OwnerInfo = useSelector((state) => state?.addressdetail?.info1);
  const dispatch = useDispatch();
  const history = useHistory();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  let data = useSelector((state) => state.cardetail);
  const reg = useSelector((state) => state.vehicledetail.bikenum);
  const [BaseUrl, setBaseURL] = useState(process.env.REACT_APP_UAT_BASE_URL);

  useEffect(() => {
    // FetchPin()
    const url = `${BaseUrl}states`;
    const config = {
      headers: {
        Authorization: "Bearer " + reg.token,
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        // console.log(res);
        const resp = res.data.data;
        // console.log(resp);
        const statesArray = Object.keys(resp).map((id) => ({
          id,
          label: resp[id],
        }));
        setOptions(statesArray);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [BaseUrl]);

  const onFinish = (values) => {
    setLoading(true);
    // console.log(values)
    // console.log(values.state)
    var data = {
      ...OwnerInfo,
      Owner: values?.fullName,
      Mobile: values?.MobileNumber,
      Email: values?.email,
      Address: values?.address,
      City: values?.city,
      State: values.state,
      Pincode: values?.pincode,
    };
    // console.log(data)
    dispatch(set_info1(data));
    setTimeout(() => {
      setLoading(false);
      setShowStep2(true);
      Ref2.current?.scrollIntoView({ behavior: "smooth" });
      //history.push("/step2");
    }, 500);
  };
  const onFinishFailed = (values) => {
    console.log(values);
    form.scrollToField(values.errorFields[0].name);
  };
  // console.log(options)
  return (
    <>
      {showStep2 ? (
        <Ownerdisplay />
      ) : (
        <div className="gridparent-skb">
          <Row gutter={[16, 16]}>
            <Col xs={24} md={24}>
              <Alert
                message={
                  <>
                    <h3>Great Choice! A few more details to go.</h3>
                    <p>
                      After payment, we will need a few minor details{" "}
                      <span className="fw-bold">
                        including a KYC (Know Your Customer)
                      </span>{" "}
                      verification to issue your policy instantly. Please fill
                      these immediately. The amount paid will be{" "}
                      <span className="fw-bold">
                        fully refunded if you fail to provide this information
                      </span>
                      .
                    </p>
                  </>
                }
                type="info"
                showIcon
              />
            </Col>
          </Row>
          <Form
            layout={formLayout}
            form={form}
            style={{ paddingTop: "10px" }}
            //requiredMark={false}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Full Name (as per PAN)"
                  name="fullName"
                  rules={[
                    {
                      required: true,
                      message: "please input Name",
                    },
                  ]}
                  initialValue={
                    OwnerInfo?.Owner
                      ? OwnerInfo?.Owner
                      : vehicleDetail?.owner_name
                  }
                >
                  <Input style={{ width: "100%" }} placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="Mobile Number"
                  name="MobileNumber"
                  rules={[
                    {
                      required: true,
                      // type: 'number',
                      message: "please input Mobile Number",
                    },
                  ]}
                  initialValue={OwnerInfo?.Mobile}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="Mobile Number"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please Input Email",
                    },
                  ]}
                  initialValue={OwnerInfo?.Email}
                >
                  <Input
                    autoComplete="off"
                    style={{ width: "100%" }}
                    placeholder="Email"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="Address"
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "please input Address",
                    },
                  ]}
                  initialValue={
                    OwnerInfo?.Address
                      ? OwnerInfo?.Address
                      : vehicleDetail?.present_address
                  }
                >
                  <TextArea
                    rows={1}
                    style={{ width: "100%" }}
                    placeholder="Address"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  // {...formItemLayout}
                  label="City"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "please input City",
                    },
                  ]}
                  initialValue={OwnerInfo?.City}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="City/District"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="state"
                  label="state"
                  rules={[
                    {
                      required: true,
                      message: "Please select State",
                    },
                  ]}
                  initialValue={OwnerInfo?.State}
                >
                  <Select
                    // defaultValue="Search for a state"
                    placeholder="Search for a state"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    options={options?.map((p) => ({
                      value: p.label,
                      label: p.label,
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  // {...formItemLayout}
                  label="Pincode"
                  name="pincode"
                  rules={[
                    {
                      required: true,
                      message: "please input Pincode",
                    },
                  ]}
                  initialValue={OwnerInfo?.Pincode}
                >
                  <Input style={{ width: "100%" }} placeholder="Pincode" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item style={{ textAlign: "center" }}>
                  {showStep2 ? null : (
                    <Button
                      loading={loading}
                      style={{ background: "#293890", border: "#293890" }}
                      type="primary"
                      htmlType="submit"
                    >
                      Proceed to Nominee Details
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
}

export { OwnerProposal1 };
